export type IntersectionCallbackType = (entry: IntersectionObserverEntry) => void

export type IntersectionConfigType = {
  callbacks: WeakMap<Element, IntersectionCallbackType>
  observer: IntersectionObserver
}

export type IntersectionSlugType = 'halfInView' | 'inView' | 'nearView'

export type HeightAvailableConfigType = {
  addElement: (el: HTMLElement) => void
  deleteElement: (el: HTMLElement) => void
}

export const HEADER_HEIGHT_CSS_VAR = '--layout-header-height'
export const HEADER_HEIGHT_FALLBACK = 56
export const HEIGHT_AVAILABLE_CSS_VAR = '--height-available'

export const INTERSECTION_CONFIG: Record<IntersectionSlugType, IntersectionObserverInit> = {
  halfInView: {
    threshold: 0.5,
  },
  inView: {
    rootMargin: '25% 0px',
    threshold: 0,
  },
  nearView: {
    rootMargin: '100% 0px',
    threshold: 0,
  },
}
